import { useApolloClient } from '@apollo/client';

import type {
  AiOriginalImageFragment,
  GetAiOriginalImageOrientationQuery,
  GetAiOriginalImageOrientationQueryVariables,
} from 'src/shared/graphql/generated';
import { GetAiOriginalImageOrientationDocument } from 'src/shared/graphql/generated';

export interface UseImageOrientationOptions {
  aiOriginalImageId?: AiOriginalImageFragment['id'];
}

export const useImageOrientation = ({
  aiOriginalImageId,
}: UseImageOrientationOptions) => {
  const client = useApolloClient();
  const originalImageCache = client.readQuery<
    GetAiOriginalImageOrientationQuery,
    GetAiOriginalImageOrientationQueryVariables
  >({
    query: GetAiOriginalImageOrientationDocument,
    variables: { id: String(aiOriginalImageId) },
  });

  return originalImageCache?.aiOriginalImage?.orientation;
};
